import React from 'react';
import {classes, style} from './doppe-viewer-list-item-interstitial-coupon-modal-panel.st.css';
import {FlexLayout} from '@wix/devzai-common-client';
import {DoppeViewerModalPanel, DoppeViewerModalPanelLayout} from '../doppe-viewer-modal-panel/doppe-viewer-modal-panel';
import {DoppeViewerModalPanelHeader} from '../doppe-viewer-modal-panel-header/doppe-viewer-modal-panel-header';
import {DoppeCouponPopup} from '../doppe-coupon-popuop/doppe-coupon-popup';
import {flexColumn, useInnerWindowController, reactCreateMemo } from '@wix/devzai-utils-react';
import {assertNotNullable, OmitStrict, PickKeys} from '@wix/devzai-utils-common';
import {useDoppeViewerLocales} from '../../client/doppe-viewer-locales/doppe-viewer-locales';
import {IDoppeViewerActionContext} from '../../doppe-sdk';
import {DoppeActionGoalType} from '../../client-server-common/doppe-action-types/doppe-action-type';

export const DoppeViewerListItemInterstitialCouponModalPanel = reactCreateMemo(function DoppeViewerListItemInterstitialCouponModalPanel (props: DoppeViewerListItemInterstitialCouponModalPanel.Props) {
    const {
        couponCode,
        itemLink,
        actionContext,
        itemId,
        itemIndex,

        className,
        ...restProps
    } = props;

    const modalController = assertNotNullable(useInnerWindowController());

    const doppeViewerLocales = useDoppeViewerLocales();

    return (
        <DoppeViewerModalPanel
            {...restProps}
            className={style(classes.root, className, flexColumn())}
            mobileLayout={DoppeViewerModalPanelLayout.FullScreen}
            desktopLayout={DoppeViewerModalPanelLayout.FullScreen}
        >
            <DoppeViewerModalPanelHeader
                title={''}
                dismissButtonCallback={() => modalController.closeWindow()}
            />
            <div
                className={style(classes.couponContainer, {}, FlexLayout.fillRemainingVerticalSpace, FlexLayout.centerContent)}
            >
                <DoppeCouponPopup
                    className={style(classes.couponPopup, {})}
                    couponCode={couponCode}
                    couponUrl={itemLink}
                    linkId={actionContext.action.id}
                    onCouponCopied={() => {
                        actionContext.reportGoalAchieved({
                            innerItemId: itemId,
                            innerItemPosition: itemIndex,
                            goalType: DoppeActionGoalType.CouponCopied
                        });
                    }}
                    onLinkClicked={() => {
                        actionContext.reportGoalAchieved({
                            innerItemId: itemId,
                            innerItemPosition: itemIndex,
                            goalType: DoppeActionGoalType.CouponCopied
                        });

                        actionContext.navigateToUrl(itemLink, true);
                    }}
                    onClose={()=>{
                        modalController.closeWindow();
                    }}
                    showBackToButton={doppeViewerLocales['backToPage']}
                    showCloseButton={false}
                    couponDescription={doppeViewerLocales['couponDescription']}
                    couponTitle={doppeViewerLocales['copyCouponTitle']}
                />
            </div>
        </DoppeViewerModalPanel>
    );
});

export namespace DoppeViewerListItemInterstitialCouponModalPanel {

    export type OmittedProps = PickKeys<DoppeViewerModalPanel.Props,
        'mobileLayout' | 'desktopLayout'
    >;

    export interface Props extends OmitStrict<DoppeViewerModalPanel.Props, OmittedProps> {
        couponCode: string;
        itemLink: string;
        actionContext: IDoppeViewerActionContext;
        itemId: string;
        itemIndex: number;
    }
}
